import React from 'react';

export const Loading = ({ size = null }) => {
  const sizeClassName = size === 'small' ? 'fa-2x' : 'fa-3x';

  return (
    <div className={sizeClassName}>
      <i className="fas fa-spinner fa-spin" />
    </div>
  );
};

export const NotAvailable = () => (
  <span>
    <strong>
      <i className="fas fa-times" />
    </strong>
  </span>
);
